import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import "babel-es6-polyfill";
import Overlay from './Overlay';
import 'react-table/react-table.css';
import font from 'font-awesome/css/font-awesome.css'; // eslint-disable-line
import NotificationContainer from '../containers/Notification';
import { Container, Row } from 'reactstrap';
import HeaderLinks from './HeaderLinks';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class App extends React.Component {

    render() {
        const { auth, children, request, roles_self, runscript } = this.props;
        return (
            <div>
                <HeaderLinks auth={auth} roles_self={roles_self}/>
                <Overlay
                    active={request.overlay}
                    message={runscript}
                />
                <NotificationContainer props/>
                <Container className="content-wrapper">
                    <Row>
                        {children}
                    </Row>
                </Container>
            </div>
        );
    }
}

App.propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.element,
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    roles_self: PropTypes.object.isRequired,
    runscript: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { auth, dispatch, notification, runscript, request, roles_self } = state;
    return { auth, dispatch, notification, runscript, request, roles_self };
}

export default connect(mapStateToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/